import type { HostCapabilities } from "./index";

export type ScreenMemory = Pick<Storage, "getItem" | "setItem">;

const SCREEN_KEY = "marlin-store:screen";

const positive = (value: number): number | undefined =>
  Number.isInteger(value) && value > 0 ? value : undefined;

const tabMemory = (): ScreenMemory | undefined => {
  try {
    return globalThis.sessionStorage;
  } catch {
    return undefined;
  }
};

const screenFromTab = (
  href: string | undefined,
  memory: ScreenMemory | undefined,
): number => {
  const fromHref = href
    ? positive(Number(new URL(href).searchParams.get("screen")))
    : undefined;
  try {
    if (fromHref) {
      memory?.setItem(SCREEN_KEY, String(fromHref));
      return fromHref;
    }
    return positive(Number(memory?.getItem(SCREEN_KEY))) ?? 1;
  } catch {
    return fromHref ?? 1;
  }
};

export const createBrowserCapabilities = (
  options: { screenId?: number; href?: string; memory?: ScreenMemory } = {},
): HostCapabilities => {
  const screenId =
    options.screenId ??
    screenFromTab(options.href, options.memory ?? tabMemory());
  return {
    screens: {
      current: () => screenId,
      displays: async () => [],
      getScreenArrangement: async (screenIds) => ({
        order: screenIds,
        positions: Object.fromEntries(
          screenIds.map((id, index) => [id, { row: 0, col: index }]),
        ),
      }),
    },
    windows: null,
    files: null,
    updater: null,
  };
};
